import { useEffect, useState } from "react";
import { API_URL } from "../../shared/constant";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Watch } from "react-loader-spinner";
import { toast } from "react-toastify";
import axios from "axios";
import Editor from 'react-simple-wysiwyg';

const AddFaqs = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const [isError, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formValue, setFormValue] = useState({
        name: "",
        answer: ""
    });


    const onSave = () => {
        if (formValue.name &&
            formValue.answer
        ) {
            setError(false);
            setLoading(true);
            const pUrl = id ? API_URL.FAQS_UPDATE : API_URL.FAQS_SAVE;
            axios.post(pUrl, formValue).then((res) => {
                if (res.data.status === 1) {
                    let message = id
                        ? "Faqs Updated Successfully."
                        : "Faqs Created Successfully.";
                    toast.success(message, { autoClose: 3000, position: "top-right" });
                    setLoading(false);
                    navigate("/settings/faqs");
                }
            })
                .finally(() => {
                    setLoading(false);
                    setError(true);
                });
        } else {
            setLoading(false);
            setError(true);
        }
    };


    const onEdit = () => {
        axios.post(API_URL.FAQS_GET, { id: id }).then((res) => {
            if (res.data.status === 1) {
                setFormValue({
                    id: res.data.data.id,
                    name: res.data.data.name ? res.data.data.name : "",
                    answer: res.data.data.answer ? res.data.data.answer : "",
                });
            }
        });
    };

    const isRequiredField = (key) => {
        return isError && !formValue[key];
    };

    const updateForm = (name, evt) => {
        setFormValue({ ...formValue, [name]: evt.target.value });
    }

    useEffect(() => {
        onEdit();
    }, []);

    return (
        <>
            <div className="row">
                <div className="col-6">
                    <h1>{id ? "Edit" : "Add"} Faqs</h1>
                </div>
                <div className="col-6">
                    <div className="d-flex align-items-center  justify-content-end">
                        <Link to={"/settings/faqs"} className="btn btn-secondary">
                            <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                        </Link>
                    </div>
                </div>
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={(event) => event.preventDefault()}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Frequently asked question<span className="required-star">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formValue.name}
                                                className={
                                                    isRequiredField("name")
                                                        ? "form-control required"
                                                        : "form-control"
                                                }
                                                id="name"
                                                onChange={(event) => {
                                                    setFormValue({
                                                        ...formValue,
                                                        name: event.target.value,
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor="answer">Answer<span className="required-star">*</span></label>
                                            <Editor value={formValue.answer}
                                                className={
                                                    isRequiredField("answer")
                                                        ? "form-control required"
                                                        : "form-control"
                                                }
                                                onChange={(e) => updateForm('answer', e)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="form-group text-right">
                                        <button
                                            type="submit"
                                            onClick={onSave}
                                            disabled={loading}
                                            className="btn btn-primary"
                                        >
                                            {loading ? (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    <Watch color={"white"} height={20} width={20} />
                                                </div>
                                            ) : (
                                                "Save"
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddFaqs;